import { ISelectModel } from 'common/models';
import API from 'services/api';

export const getUsersAll = (): Promise<ISelectModel<string>[]> =>
  API.get('/api/security/users/all').then(response => response?.data);
